import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Loader2, ShieldCheck } from "lucide-react";
import { api, errMsg, fmtDate, saveBlob } from "@/lib/api";
import { Button } from "@/components/ui/button";

const RIGHTS = [
  ["Accès et portabilité", "Téléchargez toutes les données vous concernant au format JSON (bouton ci-contre)."],
  ["Rectification", "Votre nom et votre email se modifient depuis l'icône de profil en haut à droite."],
  ["Effacement", "Demandez-le à l'administrateur : vos documents professionnels sont transmis à un collègue, vos données personnelles sont supprimées ou anonymisées."],
  ["Opposition et limitation", "Contactez le responsable du traitement indiqué en haut de cette page."],
];

export function PrivacyPanel() {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/rgpd").then((r) => setInfo(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const exportMine = async () => {
    setBusy(true);
    try { const r = await api.get("/me/data-export", { responseType: "blob" }); saveBlob(r.data, `mes_donnees_${new Date().toISOString().slice(0, 10)}.json`); toast.success("Données téléchargées"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!info) return <Loader2 className="h-5 w-5 animate-spin" />;
  return (
    <div className="grid lg:grid-cols-[1fr_340px] gap-6">
      <div className="bg-white border rounded-xl p-6">
        <h3 className="font-display font-bold">Information sur vos données personnelles</h3>
        <p className="text-xs text-slate-500 mt-1">Responsable du traitement : {info.controller} · Contact : {info.dpo_email || "—"} · Version {info.notice_version}
          {info.acknowledged_at && <> · lue le {fmtDate(info.acknowledged_at)}</>}</p>
        <div className="text-sm text-slate-700 whitespace-pre-line mt-4 leading-relaxed" data-testid="privacy-notice-text">{info.notice_text}</div>
        <div className="mt-6 divide-y border-t">
          {RIGHTS.map(([t, d]) => (
            <div key={t} className="py-3 flex gap-3"><ShieldCheck className="h-4 w-4 text-emerald-600 shrink-0 mt-0.5" /><div><div className="text-sm font-semibold">{t}</div><p className="text-sm text-slate-600">{d}</p></div></div>
          ))}
        </div>
      </div>
      <div className="bg-white border rounded-xl p-5 h-fit">
        <h3 className="font-display font-bold">Mes données</h3>
        <p className="text-sm text-slate-600 mt-1">Profil, documents déposés (liste), commentaires, conversations avec l'assistant, notifications et historique de vos actions.</p>
        <Button className="w-full mt-4" onClick={exportMine} disabled={busy} data-testid="privacy-export-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Download className="h-4 w-4 mr-2" />}Télécharger mes données
        </Button>
      </div>
    </div>
  );
}
